import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
    <motion.div
        initial={{ opacity: 0, y: 36 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
        className={className}
        {...rest}
    >
        {children}
    </motion.div>
);

export const SectionTag = ({ index, label }) => (
    <FadeUp className="flex items-center gap-4 mb-8">
        <span className="font-mono-meta text-xs tracking-[0.35em] text-[#A855F7]">
            {index}
        </span>
        <span className="h-px w-12 bg-[#A855F7]/50" />
        <span className="font-mono-meta text-xs tracking-[0.35em] text-slate-400 uppercase">
            {label}
        </span>
    </FadeUp>
);
